// Core Modules
import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

// External Modules
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

// Components
import { MainNavigationComponent } from '@shared/components/main-navigation/main-navigation.component';
import { UserSettingsComponent } from '@shared/components/header/user-settings/user-settings.component';

// Services
import { ConfigService } from '@core/services/config/config.service';

// Models
import { HeaderContentModel } from '@shared/models/header-content.model';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, NgbCollapseModule, MainNavigationComponent, UserSettingsComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  // Bindings
  @Input() hideUserSettings?: Observable<boolean>;

  // Injectors
  private readonly configService = inject(ConfigService);

  // Public Members
  public readonly headerContents: HeaderContentModel;
  public isMenuCollapsed = false;

  constructor() {
    // Load the header static contents from app-contents.json file
    this.headerContents = this.configService.getContents('header');
  }
}
